import { c as _c } from "react/compiler-runtime";
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import { capitalize } from '@winelidays/wld-tsx-2/utils';
import DurationContent from './DurationContent';
import LanguageContent from './LanguageContent';
import ParticipantsNumberContent from './ParticipantsNumberContent';
import ReceptionTypeContent from './ReceptionTypeContent';
const MiscPracticals = (t0) => {
    const $ = _c(12);
    const { informations, className: t1 } = t0;
    const className = t1 === undefined ? "" : t1;
    const translate = useTranslate();
    let t2;
    if ($[0] !== informations) {
        t2 = <>
      <LanguageContent informations={informations}/>
      <DurationContent informations={informations}/>
      <ParticipantsNumberContent informations={informations}/>
      <ReceptionTypeContent informations={informations}/></>;
        $[0] = informations;
        $[1] = t2;
    }
    else {
        t2 = $[1];
    }
    const leftContent = t2;
    const t3 = `flex flex-col ${className}`;
    let t4;
    if ($[2] !== translate) {
        t4 = capitalize(translate("practical.practical_information.label"));
        $[2] = translate;
        $[3] = t4;
    }
    else {
        t4 = $[3];
    }
    let t5;
    if ($[4] !== t4) {
        t5 = <h2 className="text-title mb-5">{t4}
    </h2>;
        $[4] = t4;
        $[5] = t5;
    }
    else {
        t5 = $[5];
    }
    let t6;
    if ($[6] !== leftContent) {
        t6 = <div className="flex flex-col md:flex-row">
      <div className="flex flex-col">{leftContent}</div>
    </div>;
        $[6] = leftContent;
        $[7] = t6;
    }
    else {
        t6 = $[7];
    }
    let t7;
    if ($[8] !== t3 || $[9] !== t5 || $[10] !== t6) {
        t7 = <><div className={t3}>{t5}{t6}
      </div></>;
        $[8] = t3;
        $[9] = t5;
        $[10] = t6;
        $[11] = t7;
    }
    else {
        t7 = $[11];
    }
    return t7;
};
export default MiscPracticals;
